import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgChevronLeft" data-sentry-source-file="chevron-left.tsx">
    <g clipPath="url(#chevron-left_svg__a)" data-sentry-element="g" data-sentry-source-file="chevron-left.tsx">
      <path fill="#263E6A" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" data-sentry-element="path" data-sentry-source-file="chevron-left.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="chevron-left.tsx">
      <clipPath id="chevron-left_svg__a" data-sentry-element="clipPath" data-sentry-source-file="chevron-left.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="chevron-left.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgChevronLeft;